// extracted by mini-css-extract-plugin
export default {"actionsContainer":"priceList_actionsContainer__3sgNi","actionsDescription":"priceList_actionsDescription__wy59w"};